export default "__VITE_ASSET__af21bc50__"